import { useCallback, useState } from 'react';
import { TextField } from '@mui/material';
import FormDialog from 'components/Dialogs/FormDialog';

interface SaveWaterfallViewDialogProps {
  open: boolean;
  isSaving: boolean;
  onSave: (name: string) => Promise<void>;
  onClose: () => void;
}

const SaveWaterfallViewDialog = ({ open, isSaving, onSave, onClose }: SaveWaterfallViewDialogProps) => {
  const [name, setName] = useState('');

  const handleSave = useCallback(async () => {
    if (!name.trim()) return;
    await onSave(name.trim());
    setName('');
  }, [name, onSave]);

  const handleClose = useCallback(() => {
    setName('');
    onClose();
  }, [onClose]);

  return (
    <FormDialog
      open={open}
      title="Save Waterfall View"
      isValid={name.trim().length > 0}
      isLoading={isSaving}
      onSave={handleSave}
      onClose={handleClose}
      customButtonLabel="Save View"
      showCancelButton>
      <TextField
        autoFocus
        fullWidth
        label="View Name"
        value={name}
        onChange={e => setName(e.target.value)}
        inputProps={{ 'data-testid': 'waterfall-view-name-input' }}
        onKeyDown={e => {
          if (e.key === 'Enter' && name.trim()) {
            handleSave();
          }
        }}
      />
    </FormDialog>
  );
};

export default SaveWaterfallViewDialog;
